/** @jsxImportSource @emotion/react */
import {
  Button,
  createStyles,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { ApiKeyModal } from './ApiKeyModal';
import useApiKey from './useApiKey';

export const ApiKey = () => {
  const styles = useStyles();
  const { spacing } = useTheme();
  const { apiKey, loading, onGenerateApiKey, onClose } = useApiKey();

  return (
    <div css={[styles.container]}>
      <div
        css={{
          flexGrow: 1,
          marginRight: spacing.xs,
        }}
      >
        <Typography variant="subtitle">Api key</Typography>
        <div
          css={{
            marginTop: spacing.xxs,
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.xxs,
          }}
        >
          <Typography variant="bodySmall">
            This is where you can generate a new API key. Any previous API keys
            that you have issued will be deleted in 7 days. Make sure to copy
            and store it securely now — for security reasons, it will disappear
            after you leave or refresh the page.
          </Typography>
        </div>
      </div>
      <Button
        text="Generate API Key"
        variant="primary"
        disabled={loading}
        onClick={onGenerateApiKey}
        testId="primary-button"
      />
      {apiKey ? <ApiKeyModal apiKey={apiKey} onClose={onClose} /> : null}
    </div>
  );
};
const useStyles = createStyles(({ sizing, spacing, palette }) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: sizing.large,
    marginTop: spacing.xxxs,
    backgroundColor: palette.white,
    padding: spacing.s,
  },
}));
